import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'
import { WidgetsServices } from '@/services/modules/widgets.service'
import store from '@/store'
import { APIWidget } from '@/models/api/widget.model'
import { Filter } from '@/interfaces/filter.interface'
import { GripItem } from '@/interfaces/grip-item.interface'

@Module
export default class WidgetsStore extends VuexModule {
    widgets: object[] = []
    widgetsPaginate: object[] = []
    widgetForm: object|null = null

    @Mutation
    updateWidgets (newWidgets: object[]) {
        this.widgets = newWidgets
    }

    @Mutation
    widgetsPaginatePaginate (newWidgets: object[]) {
        this.widgetsPaginate = newWidgets
    }

    @Mutation
    updateWidget (widgetForm: object) {
        this.widgetForm = widgetForm
    }

    @Action
    getWidgets () {
        return new Promise((resolve) => {
            WidgetsServices.getWidgets()
                .then(resp => {
                    store.commit('updateWidgets', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getWidgetsPaginate (params: { page: number; filters?: Filter[]; limit: number }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = { page: params.page, limit: params.limit }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            WidgetsServices.getWidgetsPaginate(newParams)
                .then(resp => {
                    store.commit('widgetsPaginatePaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getWidgetsById (id: number) {
        return new Promise((resolve) => {
            WidgetsServices.getWidgetsById(id)
                .then(resp => {
                    store.commit('updateWidget', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editWidgets (params: APIWidget) {
        params = new APIWidget(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIWidget)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            WidgetsServices.editWidgets(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createWidgets (params: APIWidget) {
        params = new APIWidget(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIWidget)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            WidgetsServices.createWidgets(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteWidgets (id: number) {
        return new Promise((resolve) => {
            WidgetsServices.deleteWidgets(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    savePreferences (data: GripItem[]) {
        const userId = store.state.AuthStore?.auth?.user?.userId
        if (userId && data.length > 0) {
            data = data.map(x => { x.data = []; return x })
            localStorage.setItem('widgets', JSON.stringify({ userId, layouts: data }))
        }
    }
}
